import { Component, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
  selector: 'xmed-image-view',
  standalone: true,
  imports: [],
  templateUrl: './image-view.component.html',
  styleUrl: './image-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageViewComponent {
  imageUrl = input.required<string>();
}
